/* global analytics */
import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'

import { media } from '../../styles/media'

import Vimeo from '../Vimeo'

import ArrowLeft from '../icons/ArrowLeft'
import ArrowRight from '../icons/ArrowRight'
import CrossOutIcon from '../icons/CrossOut'
import VideoIcon from '../icons/Video'

import Modal from './Modal'
import StreamableVideo from './StreamableVideo'

const Container = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 800px;
`

const Header = styled.div`
  width: 100%;
  z-index: 10;
  padding: 20px;
  color: white;
  text-align: right;
  background: transparent;

  svg {
    width: 40px;
    height: 40px;
  }

  @media (min-width: 768px) {
    padding: 40px 20px;
  }
`

const Footer = styled.div`
  width: 100%;
  height: 80px;
  z-index: 10;
  background: transparent;

  @media (min-width: 768px) {
    height: 120px;
  }
`

const RatioWrapper = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 0;
  padding-bottom: 75%;
`

const Wrapper = styled.div`
  position: relative;
  height: 100%;

  margin: 0 -20px;

  ${media.md`
    width: 100%;
    margin: 0;
  `}

  @media (min-width: 992px) {
    left: -75px;
  }
`

const MainSliderWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  height: 100%;
  width: 100%;
  left: 0;
  top: -1px;

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide {
    display: flex;
    background: black;
  }

  .slick-slide > div {
    width: 100%;
  }
`

const MainSlide = styled.div`
  height: 100%;
  width: 100%;

  background-color: black;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const SideSliderWrapper = styled.div`
  width: 100vw;
  height: 150px;
  background: rgba(0, 0, 0, 0.6);
  position: relative;
  overflow: hidden;

  @media (min-width: 992px) {
    width: 150px;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);

    .slick-slider,
    .slick-list,
    .slick-track {
      height: 100% !important;
      min-height: 100% !important;
      max-height: 100% !important;
    }
  }
`

const SideSlide = styled.div`
  position: relative;
  display: flex !important;
  align-items: center;
  justify-content: center;

  height: 120px !important;
  width: 100%;

  border: 0 !important;
  cursor: pointer;

  background-color: black;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;

    display: block;

    color: white;
    width: 32px;

    transform: translate(-50%, -50%);
  }

  ${({ backgroundImage }) =>
    backgroundImage &&
    `
    background-color: black;
    background-image: url(${backgroundImage});
  `}
`

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  ${({ left }) => (left ? 'left: 0;' : 'right: 0;')}
  transform: translateY(-50%);

  padding: 20px;
  border: 0;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);

  svg {
    display: block;
    width: 16px;
  }
`

const CloseButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
`

const FullscreenContainer = styled.div`
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
`

const FullscreenWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  flex-direction: column;

  @media (min-width: 992px) {
    flex-direction: row;
  }
`

const FullscreenMainSliderWrapper = styled.div`
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;

  @media (min-width: 992px) {
    width: calc(100vw - 150px);
    height: 100%;
  }

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide {
    display: flex;
    background: black;
  }

  .slick-slide > div {
    width: 100%;
  }
`

export default class FullscreenSlider extends React.Component {
  constructor() {
    super()
    this.state = {
      videoPlayed: false,
    }
  }

  componentDidUpdate() {
    const { isOpen } = this.props

    setTimeout(() => {
      if (this.MainSlider && isOpen) {
        this.MainSlider.innerSlider.list.setAttribute('tabindex', 0)
        this.MainSlider.innerSlider.list.focus()
      }
    }, 0)
  }

  handleChangeSlide = (slideIndex) => {
    this.SideSlider.slickGoTo(slideIndex)
  }

  handleVideoPlayed = (url) => {
    const { videoPlayed } = this.state

    if (!videoPlayed) {
      this.setState({ videoPlayed: true })
      analytics.track('Played Video', { source: 'page', url })
    }
  }

  render() {
    const { slides, video_url, onRequestClose, isOpen } = this.props

    const MainSliderSettings = {
      arrows: false,
      beforeChange: () => this.Vimeo && this.Vimeo.pause(),
      afterChange: (next) => this.SideSlider && this.SideSlider.slickGoTo(next),
    }

    const SideSliderSettings = {
      slidesToShow: slides.length > 6 ? 6 : slides.length,
      vertical: true,
      verticalSwiping: true,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: slides.length > 3 ? 3 : slides.length,
            vertical: false,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: slides.length > 6 ? 6 : slides.length,
            vertical: false,
          },
        },
      ],
      beforeChange: (current, next) => this.MainSlider.slickGoTo(next),
    }

    return (
      <Modal
        className="c-fullscreen-modal__content fullscreen-slider-modal"
        overlayClassName="c-fullscreen-modal__overlay"
        onRequestClose={onRequestClose}
        isOpen={isOpen}
      >
        <FullscreenContainer>
          <Header onClick={onRequestClose}>
            <CloseButton onClick={onRequestClose}>
              <CrossOutIcon />
            </CloseButton>
          </Header>
          <FullscreenWrapper className="js-fullscreen-slider">
            <FullscreenMainSliderWrapper>
              <Slider
                ref={(slider) => (this.MainSlider = slider)}
                {...MainSliderSettings}
              >
                {video_url && (
                  <MainSlide>
                    <Vimeo
                      ref={(vimeo) => (this.Vimeo = vimeo)}
                      url={video_url}
                      onPlay={this.handleVideoPlayed}
                    />
                  </MainSlide>
                )}
                {slides.map((slide) =>
                  slide.type === 'video' ? (
                    <MainSlide key={`video-${slide.id}`}>
                      <StreamableVideo
                        src={slide?.streamUrl}
                        poster={slide?.posterUrl}
                        objectFit="contain"
                        browserControls
                      />
                    </MainSlide>
                  ) : (
                    <MainSlide key={slide.id}>
                      <img
                        className="lazyload"
                        data-src={slide.image.large}
                        alt="slide"
                      />
                    </MainSlide>
                  )
                )}
              </Slider>

              <div>
                <NavButton onClick={() => this.MainSlider.slickPrev()} left>
                  <ArrowLeft />
                </NavButton>
                <NavButton onClick={() => this.MainSlider.slickNext()} right>
                  <ArrowRight />
                </NavButton>
              </div>
            </FullscreenMainSliderWrapper>
            <SideSliderWrapper>
              <Slider
                ref={(slider) => (this.SideSlider = slider)}
                {...SideSliderSettings}
              >
                {video_url && (
                  <SideSlide>
                    <VideoIcon />
                  </SideSlide>
                )}
                {slides.map((slide) =>
                  slide.type === 'video' ? (
                    <SideSlide
                      key={`video-${slide.id}`}
                      backgroundImage={slide?.thumbnailUrl}
                    >
                      <VideoIcon />
                    </SideSlide>
                  ) : (
                    <SideSlide
                      key={slide.id}
                      backgroundImage={slide.image.thumb}
                    />
                  )
                )}
              </Slider>
            </SideSliderWrapper>
          </FullscreenWrapper>
          <Footer onClick={onRequestClose} />
        </FullscreenContainer>
      </Modal>
    )
  }
}
